module.exports = __webpack_public_path__ + "assets/img/template-introduce-list-5.66aae947.png";